<template>
  <div>
    <h1>{{ $t('terms.cancel.title') }}</h1>
    <p>{{ $t('terms.cancel.p1') }}</p>
    <p>
      <b>{{ $t('terms.cancel.b1') }}</b>
      {{ $t('terms.cancel.p2') }}
    </p>
    <p>
      <b>{{ $t('terms.cancel.b2') }}</b>
      {{ $t('terms.cancel.p3') }}
    </p>
    <div class="buttons">
      <Button :text="$t('button.go.back')" :on-click="() => changeStep(1)" />
      <Button
        :text="$t('terms.cancel.title')"
        :on-click="cancelRegistration"
        style-type="secondary"
      />
    </div>
  </div>
</template>

<script>
import { Button } from '@bookis/web-components'

export default {
  name: 'CancelRegistration',
  components: {
    Button
  },
  props: {
    changeStep: {
      type: Function,
      required: true
    },
    cancelRegistration: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped></style>
